import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Emergency from "./pages/Emergency";
import Contact from "./pages/Contact";
import MentionsLegales from "./pages/MentionsLegales";
import CityPage from "./pages/CityPage";
import ZonesIntervention from "./pages/ZonesIntervention";
import Faq from "./pages/Faq";
import Charte from "./pages/Charte";
import Professionnels from "./pages/Professionnels";
import AudiencePage from "./pages/AudiencePage";
import BlogHotelSaintMalo from "./pages/BlogHotelSaintMalo";
import BlogResidenceSecondaireBaieMSM from "./pages/BlogResidenceSecondaireBaieMSM";
import { CITIES } from "./lib/constants";
import { PRO_AUDIENCES } from "./lib/constants";
import ServiceCityPage from "./pages/ServiceCityPage";
import NotFound from "./pages/NotFound";
import { SERVICE_CITY_ROUTES } from "./lib/seoPages";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/urgence" element={<Emergency />} />
            <Route path="/professionnels" element={<Professionnels />} />
            {PRO_AUDIENCES.map((a) => (
              <Route
                key={a.slug}
                path={`/serrurier-${a.slug}`}
                element={<AudiencePage audienceSlug={a.slug} />}
              />
            ))}
            <Route path="/contact" element={<Contact />} />
            <Route
              path="/blog/serrurier-hotel-saint-malo"
              element={<BlogHotelSaintMalo />}
            />
            <Route
              path="/blog/securiser-residence-secondaire-baie-mont-saint-michel"
              element={<BlogResidenceSecondaireBaieMSM />}
            />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/charte-transparence" element={<Charte />} />
            <Route path="/zones-intervention" element={<ZonesIntervention />} />
            {CITIES.map((c) => (
              <Route
                key={c.slug}
                path={`/serrurier-${c.slug}`}
                element={<CityPage citySlug={c.slug} />}
              />
            ))}
            {SERVICE_CITY_ROUTES.map((r) => (
              <Route
                key={r.path}
                path={r.path}
                element={<ServiceCityPage serviceSlug={r.service.slug} citySlug={r.city.slug} />}
              />
            ))}
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
